(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.stockholm-living.controller.tearsheet
  (:require
   [frontend.ui.component.lp-portal.report.tearsheet.return-development.controller
    :refer
    [tvpi]]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]
   [frontend.ui.page.lp-portal.report.util :as util]))


(defn ^{:jsdoc ["@nocollapse"]} point-formatter
  []
  (this-as
   js-data-point
   (let [point (js->clj js-data-point
                        :keywordize-keys
                        true)]
     (str "Total value per unit incl. distributions: "
          (util/->multiple (:y point))))))

(defn tearsheet
  [{:keys [report-data] :as props}]
  {:tvpi (report-ctl/with-footnote
          props
          :tvpi-footnotes
          (tvpi (get-in report-data [:tearsheet :tvpi])
                {:custom-point-formatter point-formatter
                 :y-axis-title "Total value per unit incl. distributions"}))
   :return-development (report-ctl/with-footnote
                        props
                        :return-development-footnotes
                        (get-in report-data [:tearsheet :return-development]))
   :basic-information-primary (report-ctl/with-footnote
                               props
                               :basic-information-primary-footnotes
                               (get-in report-data
                                       [:basic-information-primary]))
   :basic-information-secondary (report-ctl/with-footnote
                                 props
                                 :basic-information-secondary-footnotes
                                 (get-in report-data
                                         [:basic-information-secondary]))})
